<div class="popin <%= classes %>" id="<%= id %>" role="dialog">
    <div class="popin__title-container">
        <h2 class="popin__title text--center text--h2"><%= title %></h2>
    </div>
    <div class="popin__body <%= bodyClasses %>" data-popin-body>
    </div>
</div>
